export default __webpack_public_path__ + "static/government_b.7e9f3e38347f4f28ecd72d50839fd8c6.svg";